<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <circle cx="6" cy="6" r="5.5" fill="currentColor" stroke="currentColor" />
    <path stroke="#fff" stroke-linecap="round" d="m4.158 4.315 3.614 3.614M7.772 4.158 4.158 7.772" />
  </svg>
</template>
